import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval, sqsMessageBatchSize } = formData;
  const handleSubmit = () => {
    if (formError) {
      return;
    }
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: t("aws_cloudtrail_step_subscribe.polling_interval_error_full"),
        nice_message: t("aws_cloudtrail_step_subscribe.polling_interval_error")
      });
      return;
    }
    if ((sqsMessageBatchSize == null ? void 0 : sqsMessageBatchSize.value) && (sqsMessageBatchSize.value < 1 || sqsMessageBatchSize.value > 10)) {
      setFormError({
        full_message: t("aws_cloudtrail_step_subscribe.batch_size_error_full"),
        nice_message: t("aws_cloudtrail_step_subscribe.batch_size_error")
      });
      return;
    }
    setFormError(null);
    onSubmit();
  };
  const handleSqsMessageBatchSizeChange = (errorMessage) => {
    if (errorMessage) {
      setFormError({
        full_message: errorMessage,
        nice_message: errorMessage
      });
    } else {
      setFormError(null);
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("aws_cloudtrail_step_subscribe.proceed_button"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("aws_cloudtrail_step_subscribe.polling_interval_help"),
        label: t("aws_cloudtrail_step_subscribe.polling_interval_label")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange, handleSqsMessageBatchSizeChange })
  );
};
export default StepSubscribe;
